
        // classnames-loader: automatically bind css-modules to classnames
        var classNames = require("!../../../node_modules/classnames/bind.js");
        var locals = require("!!../../../node_modules/mini-css-extract-plugin/dist/loader.js??ref--15-1!../../../node_modules/css-loader/index.js??ref--15-2!../../../node_modules/postcss-loader/src/index.js??postcss-3!../../../node_modules/sass-loader/dist/cjs.js??ref--15-4!./sectorlist.scss");
        var css = classNames.bind(locals);
        for (var style in locals) {
            if (!locals.hasOwnProperty(style)) {
                continue;
            }
            if (typeof Object.defineProperty === 'function') {
                Object.defineProperty(css, style, {value: locals[style]});
            }
            else {
                css[style] = locals[style];
            }
        }
        module.exports = css;
    